import React from 'react';
import { useNotificationMessage } from 'src/common/notification/message.hook';
import { PageSettingsProps } from 'src/pages/Settings';
import { useCurrentOrganization } from 'src/store/organization';
import { DashboardSettingsBilling } from './billing';
import { DashboardSettingsBrand } from './brand';
import { DashboardSettingsMembers } from './members';
import { DashboardSettingsOrganization } from './organization';
import { DashboardSettingsManageWorkspaces } from './manage-workspaces';
import { DashboardSettingsTheme } from './theme';
import { DashbooardSettingsIntegrations } from './integrations';
import { DashboardSettingsAccount } from './account';
import { DashboardSettingsJourneyBehavior } from './journey-behavior';
import ApiKeyManagement from '../api-integration/APIKeyManagement';

export const DashboardSettingsContent = ({ activeTab }: PageSettingsProps) => {
  const { currentOrganization } = useCurrentOrganization();
  const { setSuccessNotification } = useNotificationMessage();

  const onOrganizationSuccess = () => {
    setSuccessNotification('Organization updated successfully');
  };

  const onBrandingSuccess = () => {
    setSuccessNotification('Branding updated successfully');
  };

  if (activeTab === 'members') {
    return <DashboardSettingsMembers currentOrganization={currentOrganization} />;
  } else if (activeTab === 'organization') {
    return (
      <DashboardSettingsOrganization currentOrganization={currentOrganization} onSuccess={onOrganizationSuccess} />
    );
  } else if (activeTab === 'branding') {
    return <DashboardSettingsBrand currentOrganization={currentOrganization} onSuccess={onBrandingSuccess} />;
  } else if (activeTab === 'workspaces') {
    return <DashboardSettingsManageWorkspaces currentOrganization={currentOrganization} />;
  } else if (activeTab === 'billing') {
    return <DashboardSettingsBilling currentOrganization={currentOrganization} />;
  } else if (activeTab === 'theme') {
    return <DashboardSettingsTheme currentOrganization={currentOrganization} />;
  } else if (activeTab === 'integrations') {
    return <DashbooardSettingsIntegrations />;
  } else if (activeTab === 'account') {
    return <DashboardSettingsAccount />;
  } else if (activeTab === 'behavior') {
    return <DashboardSettingsJourneyBehavior />;
  } else if (activeTab === 'apikey'){
    return <ApiKeyManagement/>
  }

  return <span>settings</span>;
};
